import { useHtmlSnippetQuery } from "@/hooks";
import { memo, useState, useEffect, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function HtmlSnippet(_ref) {
  let {
    id,
    idKey
  } = _ref;
  const snippet = useRef();
  const {
    0: html,
    1: setHtml
  } = useState("");
  const {
    data
  } = useHtmlSnippetQuery({
    variables: {
      id,
      idKey
    }
  });
  const {
    content,
    style,
    javascript
  } = (data === null || data === void 0 ? void 0 : data.htmlSnippet) || {};
  useEffect(() => {
    if (snippet.current) {
      let _html = "";
      if (style) {
        _html += `<style>${style}</style>`;
      }
      if (content) {
        _html += `${content}`;
      }
      setHtml(_html);
      if (javascript) {
        const scriptEl = document.createElement("script");
        scriptEl.type = "text/javascript";
        scriptEl.async = true;
        scriptEl.innerHTML = `
      (function () {
        try {
          ${javascript}
        } catch (e) {
          console.error(e);
        }
      }());`;
        snippet.current.appendChild(scriptEl);
      }
    }
  }, [snippet.current, content, style, javascript]);
  return /*#__PURE__*/_jsx("div", {
    className: `snippet-${id}`,
    ref: snippet,
    children: /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: html
      }
    })
  });
}
export default /*#__PURE__*/memo(HtmlSnippet);